export const namespaced = true;

export const state = {
  genders: [
    {
      id: 1,
      name: '男性',
    },
    {
      id: 2,
      name: '女性',
    },
    {
      id: 3,
      name: 'その他',
    },
  ],
};

export const getters = {
  getGenderById: (state) => (id) => {
    return state.genders.find((item) => item.id == id);
  },
};
